const validateDomiciliation = "validateDomiciliation";
const domiciliationCreate = "create";

export const DomiciliationApi = {
  async getHasDomiciliationService(reference, username, serviceId) {
    const { REACT_APP_DOMICILIATION_API_URL, REACT_APP_DOMICILIATION_API_KEY } =
      process.env;
    return new Promise((resolve, reject) => {
      fetch(
        `${REACT_APP_DOMICILIATION_API_URL}/${validateDomiciliation}?claroId=${username}&serviceId=${serviceId}&reference=${reference}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": REACT_APP_DOMICILIATION_API_KEY,
          },
        }
      )
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          console.log("Has domiciliation success");
          return resolve(data);
        })
        .catch(function (err) {
          console.log("Has domiciliation error");
          reject(err);
        });
    }).catch((e) => {
      console.log(e, "Has domiciliation catch error");
      throw e;
    });
  },

  async domiciliationAccountService(
    authorizationTyC,
    claroId,
    detail,
    dueDate,
    expirationDate,
    externalId,
    initialDay,
    maxAmount,
    msisdn,
    msisdnCipher,
    periodicity,
    pin,
    productId,
    reference,
    serviceHolder,
    serviceId
  ) {
    const { REACT_APP_DOMICILIATION_API_URL, REACT_APP_DOMICILIATION_API_KEY } =
      process.env;
    const dataBodyRequest = {
      authorizationTyC,
      claroId,
      detail,
      dueDate,
      expirationDate,
      externalId,
      initialDay,
      maxAmount,
      msisdn,
      msisdnCipher,
      periodicity,
      pin,
      productId,
      reference,
      serviceHolder,
      serviceId,
    };
    return new Promise((resolve, reject) => {
      fetch(`${REACT_APP_DOMICILIATION_API_URL}/${domiciliationCreate}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": REACT_APP_DOMICILIATION_API_KEY,
        },
        body: JSON.stringify(dataBodyRequest),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          console.log("Domiciliation success");
          return resolve(data);
        })
        .catch(function (err) {
          console.log("Domiciliation error");
          reject(err);
        });
    }).catch((e) => {
      console.log(e, "Domiciliation catch error");
      throw e;
    });
  },
};
